import React, { Component } from 'react';

import {
  BrowserRouter as Router,
  Route,
  browserHistory
} from 'react-router-dom';

import Navbar from './components/navbar.jsx';
import Footer from './components/footer.jsx';

import Home from './components/home.jsx';
import Articles from './components/articles.jsx';
import About from './components/about.jsx';
import Contact from './components/contact.jsx';
import Login from './components/login.jsx';
import Register from './components/register.jsx';
import Profile from './components/profile.jsx';
import Logout from './components/logout.jsx';
import Create from './components/create.jsx';
import SunumEligard from './components/sunum.jsx';

class App extends Component {

        state = {
            preloading: true
        }
        componentDidMount() {
            setTimeout(
                () => this.setState(() => ({ preloading: false })),
                3000
            );
        }



  render() {
    const { preloading } = this.state;

    return (
      <Router history={browserHistory}>
        <div className="container overflow-hidden">
        
                    
          			<Navbar />
            		<Route exact path="/" component={Home} />
                    

        
            
            
            
            
            <Route path="/articles/:id?" component={Articles} />
            <Route path="/about" component={About} />
            <Route path="/contact" component={Contact} />
            <Route path="/create" component={Create} />
            <Route path="/sunum-eligard/:id?" component={SunumEligard} />
            <Route path="/sunum-hippurin/:id?" component={SunumEligard} />
            <Route path="/user/password" component={Register} />
            <Route path="/user/login" component={Login} />
            <Route path="/user/profile" component={Profile} />
            <Route path="/user/logout" component={Logout} />
          <Footer />
        </div>
      </Router>
    );
}}

export default App



// WEBPACK FOOTER //
// src/App.js